(ns dre.fx
  (:require
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   #_["downloadjs" :as download]
   [re-frame.core :as rf]))

(defn download*
  [blob filename mimetype]
  (let [a (.createElement js/document "a")]
    (set! (.-href a) (.createObjectURL js/URL blob))
    (set! (.-download a) filename)
    (set! (.-display (.-style a)) "none")
    (.appendChild (.-body js/document) a)
    (.click a)
    (.removeChild (.-body js/document) a)))

(rf/reg-fx
 ::download
 (fn [{:keys [content filename mimetype utf8]}]
   (let [;; see https://stackoverflow.com/questions/42715966/preserve-utf-8-bom-in-browser-downloads
         ;; https://stackoverflow.com/questions/17879198/adding-utf-8-bom-to-string-blob
         ;; mimetype "application/octet-stream"
         data (if utf8
                (js/Array. (js/Uint8Array. [0xEF, 0xBB, 0xBF]) content)
                (js/Array. content))
         content (js/Blob. data {:type mimetype})]
     (download* content filename mimetype))))

(rf/reg-event-fx
 ::download
 [rf/trim-v]
 (fn-traced [_ [data]]
            {::download data}))
